export enum NotificationEvent {
    InspectionsUpdated = 'InspectionsUpdated',
    InspectionUpdated = 'InspectionUpdated',
    CategoryUpdated = 'CategoryUpdated'
}
